module.exports = __webpack_public_path__ + "img/flag-en.f66753ee.svg";